import type { CompositeCardConfig } from '../../state/cardSchema';
import { CardRenderer } from '../../CardRenderer';
import { Section } from '../Section';
import styles from './CompositeCard.module.css';

export type CompositeCardProps = {
  card: CompositeCardConfig;
};

export const CompositeCard = ({ card }: CompositeCardProps) => {
  return (
    <Section id={card.id} title={card.title} subtitle={card.subtitle} info={card.info}>
      <div className={styles.stack}>
        {card.children.map((child) => (
          <CardRenderer key={child.id} card={child} />
        ))}
      </div>
    </Section>
  );
};
